"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[9186],{

/***/ 7013:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ getInitialValues)
/* harmony export */ });
/* harmony import */ var nestify_anything__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98959);
/* harmony import */ var elephant_web_client_new_formConstants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23251);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99129);



const omitInsuranceType = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["insuranceType", "__typename"]);
const getInitialValues = (patient) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const { currentVisit } = patient;
  const visitInsuranceProvider = (_b = currentVisit == null ? void 0 : currentVisit.insuranceList) == null ? void 0 : _b[((_a = currentVisit == null ? void 0 : currentVisit.insuranceList) == null ? void 0 : _a.length) - 1];
  const visitInsuranceDetails = (_c = visitInsuranceProvider == null ? void 0 : visitInsuranceProvider.visitInsuranceDetails) != null ? _c : {};
  const unflat = {
    ...(0,nestify_anything__WEBPACK_IMPORTED_MODULE_2__/* .nestifyObject */ .Q)({
      [elephant_web_client_new_formConstants__WEBPACK_IMPORTED_MODULE_0__/* .INSURANCE_TYPE_NAME */ .jX]: (_e = (_d = patient.insurance) == null ? void 0 : _d.insuranceType) != null ? _e : "",
      "insurance.insuranceDetails": (_g = (_f = patient.insurance) == null ? void 0 : _f.insuranceDetails) != null ? _g : omitInsuranceType(patient.insurance),
      "insurance.visitInsuranceDetails": visitInsuranceDetails,
      [elephant_web_client_new_formConstants__WEBPACK_IMPORTED_MODULE_0__/* .PATIENT_HAS_INSURANCE */ .jG]: (patient == null ? void 0 : patient.insurance) ? elephant_web_client_new_formConstants__WEBPACK_IMPORTED_MODULE_0__/* .PatientHasInsurance.YES */ .xl.YES : patient.patientHasInsurance
    })
  };
  return unflat;
};


/***/ }),

/***/ 854:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(948);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95061);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61800);


const useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((theme) => ({
  propertyContainer: {
    alignItems: "center",
    "& pre": {
      fontFamily: theme.typography.fontFamily
    }
  },
  printValue: {
    display: "inline-block",
    marginLeft: theme.spacing(1)
  },
  printLabel: {
    display: "inline-block"
  },
  printWrapper: {
    marginBottom: "4px"
  }
}));
const InvestigationResults = ({
  items,
  print
}) => {
  const classes = useStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    container: true,
    spacing: print ? 0 : 2
  }, items.map(([property, content]) => {
    const { title, meta, type } = property;
    const isCustomComponent = !!(meta == null ? void 0 : meta.component);
    if (print) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        item: true,
        xs: 12,
        className: classes.printWrapper,
        key: title
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: classes.printLabel
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        variant: "body1"
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", null, `${title}:`))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: classes.printValue
      }, content));
    }
    if (!isCustomComponent && type === "object") {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        item: true,
        xs: 12,
        key: title
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        mb: 1
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        variant: "body1"
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", null, title))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        pl: 2
      }, content));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      item: true,
      xs: 12,
      key: title
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      container: true,
      spacing: 2,
      className: classes.propertyContainer
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      item: true,
      xs: 12,
      sm: 6
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      variant: "body2"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", null, title))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      item: true,
      xs: 12,
      sm: 6
    }, content)));
  }));
};
InvestigationResults.defaultProps = {
  print: false
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InvestigationResults);


/***/ }),

/***/ 74100:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* reexport */ DynamicInvestigationResults_DynamicInvestigationResults)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/client/forms/DynamicFormFields/dynamicFieldHOC.tsx
var dynamicFieldHOC = __webpack_require__(79683);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
;// CONCATENATED MODULE: ./src/client/investigations/DynamicInvestigationResults/UnitResult.tsx



const UnitResult = (props) => {
  var _a, _b, _c;
  const { property } = props;
  const { meta, orderedProperties } = property;
  const { units } = meta;
  const value = (_a = orderedProperties.find((p) => p.name === "value")) == null ? void 0 : _a.value;
  if (!value) {
    return /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
      variant: "body1"
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "investigation.result.unit.empty",
      defaultMessage: "-"
    }));
  }
  let unitTitle = "";
  const unitDetails = orderedProperties.find((p) => p.name === "unit");
  if (unitDetails) {
    const unitValue = unitDetails.value ? unitDetails.value : unitDetails.default;
    unitTitle = (_c = (_b = units == null ? void 0 : units.find((u) => u.value === unitValue)) == null ? void 0 : _b.title) != null ? _c : "";
  }
  const display = `${value} ${unitTitle}`;
  return /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, display);
};
/* harmony default export */ const DynamicInvestigationResults_UnitResult = (react.memo(UnitResult));

// EXTERNAL MODULE: ./src/client/forms/DynamicFormFields/DynamicFormFieldsContext.tsx
var DynamicFormFieldsContext = __webpack_require__(35792);
;// CONCATENATED MODULE: ./src/client/investigations/DynamicInvestigationResults/DynamicResult.tsx




const DefaultDynamicResultComponent = ({
  property
}) => /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
  variant: "body1"
}, property.value);
const DynamicResultFieldsContext = (0,DynamicFormFieldsContext/* createDynamicFieldsContext */.y)();
const DynamicResult = (props) => {
  const { property } = props;
  const { meta, value } = property;
  const type = property.type;
  const { fieldMap } = react.useContext(DynamicResultFieldsContext);
  if (meta == null ? void 0 : meta.component) {
    const Component2 = fieldMap[meta.component];
    if (!Component2) {
      console.warn(
        `DynamicResult could not render ${meta.component} as it does not exist in the fieldMap.`
      );
      return null;
    }
    return /* @__PURE__ */ react.createElement(Component2, {
      property
    });
  }
  const Component = fieldMap[type];
  if (Component) {
    return /* @__PURE__ */ react.createElement(Component, {
      property
    });
  }
  if (property.enum) {
    const indexOf = property.enum.indexOf(property.value);
    const display = meta.enumTitles[indexOf];
    return /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
      variant: "body1"
    }, display);
  }
  if (!value) {
    return /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
      variant: "body1"
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "investigation.result.empty",
      defaultMessage: "-"
    }));
  }
  return /* @__PURE__ */ react.createElement(DefaultDynamicResultComponent, {
    property
  });
};
/* harmony default export */ const DynamicInvestigationResults_DynamicResult = (DynamicResult);

// EXTERNAL MODULE: ./src/client/investigations/DynamicInvestigationResults/InvestigationResults.tsx
var InvestigationResults = __webpack_require__(854);
;// CONCATENATED MODULE: ./src/client/investigations/DynamicInvestigationResults/DynamicInvestigationResults.tsx





const withValue = (property) => {
  if (property.value && property.value !== property.default) {
    return true;
  }
  if (property.orderedProperties) {
    return property.orderedProperties.some(
      (childProperty) => withValue(childProperty)
    );
  }
  return false;
};
const DynamicInvestigationResults = ({
  property: { orderedProperties },
  print
}) => {
  const items = orderedProperties.reduce(
    (result, currentProperty, i) => {
      if (withValue(currentProperty)) {
        result.push([
          currentProperty,
          /* @__PURE__ */ react.createElement(DynamicInvestigationResults_DynamicResult, {
            property: currentProperty,
            key: i
          })
        ]);
      }
      return result;
    },
    []
  );
  return /* @__PURE__ */ react.createElement(InvestigationResults/* default */.Z, {
    items,
    print
  });
};
const DynamicInvestigationResultsContainer = (props) => {
  const { fieldMap, ...restProps } = props;
  return /* @__PURE__ */ react.createElement(DynamicResultFieldsContext.Provider, {
    value: { fieldMap }
  }, /* @__PURE__ */ react.createElement(DynamicInvestigationResults, {
    ...restProps
  }));
};
const defaultFieldMap = {
  BmiInput: (0,dynamicFieldHOC/* default */.Z)(DynamicInvestigationResults_UnitResult),
  UnitInput: (0,dynamicFieldHOC/* default */.Z)(DynamicInvestigationResults_UnitResult),
  TextArea: (0,dynamicFieldHOC/* default */.Z)(DefaultDynamicResultComponent),
  object: (0,dynamicFieldHOC/* default */.Z)(DynamicInvestigationResults),
  TEWSScoreInput: (0,dynamicFieldHOC/* default */.Z)(DynamicInvestigationResults_UnitResult)
};
DynamicInvestigationResults.defaultProps = {
  print: false,
  property: {
    orderedProperties: []
  }
};
DynamicInvestigationResultsContainer.defaultProps = {
  fieldMap: defaultFieldMap,
  print: false
};
/* harmony default export */ const DynamicInvestigationResults_DynamicInvestigationResults = (react.memo(DynamicInvestigationResultsContainer));

;// CONCATENATED MODULE: ./src/client/investigations/DynamicInvestigationResults/index.ts



/***/ }),

/***/ 85855:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DD": () => (/* binding */ useInvestigationActivitiesContext),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "b9": () => (/* binding */ limit),
/* harmony export */   "cv": () => (/* binding */ offset)
/* harmony export */ });
/* unused harmony export InvestigationActivitiesContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24520);
/* harmony import */ var _utils_useEvictCacheOnUnmount__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43566);
/* harmony import */ var _common_PatientProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51971);
/* harmony import */ var elephant_web_client_clinical_engine_investigationActivities_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18712);
/* harmony import */ var _generated_InvestigationActivitiesProvider_gql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30053);
/* harmony import */ var _elephant_healthcare_launchdarkly_provider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45309);
/* harmony import */ var _common_featureFlags__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72766);








_apollo_client__WEBPACK_IMPORTED_MODULE_7__/* .gql */ .Ps`
  query InvestigationActivitiesProvider(
    $input: InvestigationActivitiesInput!
    $offset: Int!
    $limit: Int!
  ) {
    investigationActivitiesPaginatedOffset(input: $input, offset: $offset, limit: $limit) {
      items {
        ...InvestigationActivityFragment
        ... on TestResult {
          _id
          clinic
          interpreter
          patientId: patient
          results {
            investigation
            name
            result {
              name
              value
              displayName
              unit
            }
          }
          meta {
            created
            updated
          }
        }
      }
      total
      hasMore
      offset
      limit
    }
  }
  ${elephant_web_client_clinical_engine_investigationActivities_graphql__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fragments.investigationActivity */ .Z.fragments.investigationActivity}
`;
const offset = 0;
const limit = 100;
const InvestigationActivitiesContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const InvestigationActivitiesProvider = ({
  children,
  patientUuid: patientUuidOverride
}) => {
  const patientContext = (0,_common_PatientProvider__WEBPACK_IMPORTED_MODULE_2__/* .usePatientContext */ .p)();
  const interOrgFlag = (0,_elephant_healthcare_launchdarkly_provider__WEBPACK_IMPORTED_MODULE_5__/* .useFeatureFlag */ .ye)(
    _common_featureFlags__WEBPACK_IMPORTED_MODULE_6__/* .featureFlags.patient.territoryDataSharing */ .VH.patient.territoryDataSharing
  );
  const patientUuid = patientUuidOverride != null ? patientUuidOverride : patientContext == null ? void 0 : patientContext.uuid;
  const result = (0,_generated_InvestigationActivitiesProvider_gql__WEBPACK_IMPORTED_MODULE_4__/* .useInvestigationActivitiesProviderQuery */ .tt)({
    variables: {
      input: { patientUuid, interOrgFlag },
      offset,
      limit
    }
  });
  (0,_utils_useEvictCacheOnUnmount__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    id: "ROOT_QUERY",
    fieldName: "investigationActivitiesPaginatedOffset",
    args: { input: { patientUuid } }
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InvestigationActivitiesContext.Provider, {
    value: result
  }, children);
};
const useInvestigationActivitiesContext = () => {
  const context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(InvestigationActivitiesContext);
  if (context === void 0) {
    throw new Error(
      "useInvestigationActivitiesContext must be used within a InvestigationActivitiesProvider"
    );
  }
  return context;
};
InvestigationActivitiesProvider.fragments = {
  investigationActivity: elephant_web_client_clinical_engine_investigationActivities_graphql__WEBPACK_IMPORTED_MODULE_3__/* ["default"].fragments.investigationActivity */ .Z.fragments.investigationActivity
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InvestigationActivitiesProvider);


/***/ }),

/***/ 34726:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ investigations_InvestigationActivityCard)
});

// UNUSED EXPORTS: MUTATION_DELETE_INVESTIGATION_ACTIVITIES

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var graphql_tag_lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var mui_style_dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./src/ui/index.ts + 7 modules
var ui = __webpack_require__(31630);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-card@0.2.10_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@elephant-healthcare/mui-card/dist/module.js
var mui_card_dist_module = __webpack_require__(21534);
// EXTERNAL MODULE: ./src/client/investigations/RequestedBubble.tsx
var RequestedBubble = __webpack_require__(56778);
// EXTERNAL MODULE: ./src/client/investigations/styles/common.js
var common = __webpack_require__(71011);
// EXTERNAL MODULE: ./src/client/investigations/intlStrings.ts
var intlStrings = __webpack_require__(2818);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Error.js
var Error = __webpack_require__(12017);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-modal@0.3.9_vyafebljftw2lpwbgyprbkkpkm/node_modules/@elephant-healthcare/mui-modal/dist/module.js
var mui_modal_dist_module = __webpack_require__(27832);
;// CONCATENATED MODULE: ./src/client/investigations/DeleteInvestigationModal.tsx








const useStyles = (0,mui_style_dist_module/* makeStyles */.Z)((theme) => ({
  body: {
    overflow: "auto"
  },
  warning: {
    borderRadius: "5px"
  },
  warningBreakout: {
    color: theme.palette.inpatient.light
  },
  warningIcon: {
    color: theme.palette.error.main,
    height: 20,
    width: 20,
    borderRadius: 10,
    outline: `5px solid ${theme.palette.inpatient.warningOutline}`
  }
}));
function DeleteInvestigationModal(props) {
  const { open, onClose, onSubmit, investigationName } = props;
  const classes = useStyles();
  const handleSubmit = (0,react.useCallback)(() => {
    onSubmit();
  }, [onSubmit]);
  return /* @__PURE__ */ react.createElement(ui/* Modal */.u_, {
    open,
    onClose,
    "data-testid": "investigation-delete-modal-container"
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalHeader */.xB, {
    bgcolor: "background.paper",
    p: 0,
    m: 2
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "inline-block",
    m: 1,
    mr: 3
  }, /* @__PURE__ */ react.createElement(Error/* default */.Z, {
    className: classes.warningIcon
  })), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "inline-block"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h4"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "investigation.deletion.title",
    defaultMessage: "Delete"
  }), ` ${investigationName}`, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "investigation.deletion.title.question",
    defaultMessage: "?"
  }))))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, {
    className: classes.body,
    p: 0,
    m: 2
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexDirection: "column"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    p: 2,
    display: "flex",
    className: classes.warningBreakout
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    className: classes.warningBreakout
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "investigation.deletion.warning",
    defaultMessage: "Deleting this investigation will remove it from the lab techinician\u2019s view as well. If they are still processing this investigation they won\u2019t have a card to enter the results in."
  }))))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mr: 1
  }, /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: onClose,
    "data-testid": "investigation-delete-modal-button-cancel"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "patient.consent.denyBtn",
    defaultMessage: "Cancel"
  }))), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    color: "error",
    onClick: handleSubmit,
    "data-testid": "investigation-delete-modal-button-confirm"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "investigation.deletion.confirm",
    defaultMessage: "Delete"
  }))));
}
DeleteInvestigationModal.defaultProps = {
  open: false
};
/* harmony default export */ const investigations_DeleteInvestigationModal = (DeleteInvestigationModal);

// EXTERNAL MODULE: ./src/client/investigations/useInvestigationsCache.tsx + 1 modules
var useInvestigationsCache = __webpack_require__(71746);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
;// CONCATENATED MODULE: ./src/client/investigations/InvestigationActivityCard.tsx














const MUTATION_DELETE_INVESTIGATION_ACTIVITIES = graphql_tag_lib/* gql */.Ps`
  mutation DeleteInvestigations($input: [ID!]!) {
    deleteInvestigations(input: $input) {
      success
      investigationActivityIds
    }
  }
`;
const deleteAria = (0,lib/* defineMessage */.Em)({
  id: "investigation.card.delete.aria",
  defaultMessage: "delete-investigation"
});
const InvestigationActivityCard_useStyles = (0,mui_style_dist_module/* makeStyles */.Z)((theme) => ({
  summaryContent: {
    margin: `${theme.spacing(2)}px 0`,
    flexDirection: "column",
    "&.Mui-expanded": {
      margin: `${theme.spacing(2)}px 0 ${theme.spacing(3)}px 0`
    }
  },
  binButton: {
    margin: `${theme.spacing(-0.5)}px 0`
  },
  ...(0,common/* investigationStatusStyles */.Q)(theme)
}));
const LocationFooterItem = ({ children }) => {
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardFooterItem */.Tq, null, children));
};
const InvestigationActivityCard = ({
  children,
  title,
  subtitle,
  defaultExpanded,
  requestedDate,
  fulfiller,
  fulfilledDate,
  isRequested,
  requester,
  requestLocation,
  outcomeLocation,
  showStatus,
  investigationActivityId,
  enableDelete,
  patientUuid
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { removeInvestigationFromCache } = (0,useInvestigationsCache/* default */.Z)(patientUuid);
  const [deleteInvestigationModalOpen, setDeleteInvestigationModalOpen] = react.useState(false);
  const [deleteInvestigations] = (0,useMutation/* useMutation */.D)(
    MUTATION_DELETE_INVESTIGATION_ACTIVITIES,
    {
      onCompleted: (mutationResult) => {
        if (mutationResult.deleteInvestigations.success) {
          const idToRemove = mutationResult.deleteInvestigations.investigationActivityIds[0];
          removeInvestigationFromCache(idToRemove);
          dist_default().success(
            formatMessage({
              id: "investigations.deletion.success",
              defaultMessage: "Successfully deleted investigation request"
            })
          );
        }
      },
      onError: (error) => {
        dist_default().error(
          formatMessage(
            {
              id: "investigations.deletion.error",
              defaultMessage: "There was an error deleting the investigation: {error}"
            },
            { error: error.message }
          )
        );
        setDeleteInvestigationModalOpen(false);
      }
    }
  );
  const classes = InvestigationActivityCard_useStyles();
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(mui_card_dist_module/* Card */.Zb, {
    "data-testid": "investigation-card",
    color: mui_card_dist_module/* CardColors.INVESTIGATION */.L3.INVESTIGATION,
    expandable: true,
    defaultExpanded
  }, /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardBody */.eW, null, /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardSummary */.Jy, {
    id: "investigation-header"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "flex-start"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    flex: 1
  }, subtitle && /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardSubtitle */._R, {
    color: mui_card_dist_module/* CardColors.INVESTIGATION */.L3.INVESTIGATION,
    gutterBottom: true
  }, subtitle), /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardTitle */.ll, null, title)), enableDelete && /* @__PURE__ */ react.createElement(ui/* BinButton */.vt, {
    "data-testid": "investigation-card-delete-button",
    className: classes.binButton,
    "aria-label": formatMessage(deleteAria),
    onClick: (e) => {
      e.stopPropagation();
      setDeleteInvestigationModalOpen(true);
    }
  }), showStatus && /* @__PURE__ */ react.createElement(react.Fragment, null, isRequested ? /* @__PURE__ */ react.createElement(RequestedBubble/* default */.Z, {
    className: classes.requestedBubble
  }, /* @__PURE__ */ react.createElement("strong", null, formatMessage(intlStrings/* requestedInvestigationTranslation */.S))) : /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    marginTop: 0.5
  }, /* @__PURE__ */ react.createElement(dist_module.CheckIcon, {
    className: classes.checkIcon
  }))))), /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardDetails */.u0, null, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    mb: 3
  }, children), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, requester ? /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardFooterItem */.Tq, null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "investigationActivity.request.performer",
    defaultMessage: "Requested by:"
  }), " ", (requester == null ? void 0 : requester.name) ? `${requester.name}, ` : "", requestedDate ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(lib/* FormattedDate */.Ji, {
    value: requestedDate
  }), " ", /* @__PURE__ */ react.createElement(lib/* FormattedTime */.qN, {
    value: requestedDate
  })) : null)) : null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    item: true,
    xs: 12
  }, fulfiller ? /* @__PURE__ */ react.createElement(mui_card_dist_module/* CardFooterItem */.Tq, null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "investigationActivity.outcome.performer",
    defaultMessage: "Submitted by:"
  }), " ", (fulfiller == null ? void 0 : fulfiller.name) ? `${fulfiller.name}${fulfilledDate ? ", " : ""}` : "", fulfilledDate ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(lib/* FormattedDate */.Ji, {
    value: fulfilledDate
  }), " ", /* @__PURE__ */ react.createElement(lib/* FormattedTime */.qN, {
    value: fulfilledDate
  })) : null) : null), requestLocation && /* @__PURE__ */ react.createElement(LocationFooterItem, null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "investigationActivity.request.location",
    defaultMessage: "Request Location:"
  }), " ", requestLocation.name), outcomeLocation && /* @__PURE__ */ react.createElement(LocationFooterItem, null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "investigationActivity.outcome.location",
    defaultMessage: "Outcome Location:"
  }), " ", outcomeLocation.name))))), /* @__PURE__ */ react.createElement(investigations_DeleteInvestigationModal, {
    onClose: () => {
      setDeleteInvestigationModalOpen(false);
    },
    onSubmit: () => deleteInvestigations({
      variables: { input: [investigationActivityId] }
    }),
    open: deleteInvestigationModalOpen,
    investigationName: title
  }));
};
InvestigationActivityCard.defaultProps = {
  subtitle: null,
  requester: void 0,
  requestedDate: void 0,
  fulfiller: void 0,
  fulfilledDate: void 0,
  isRequested: false,
  defaultExpanded: false,
  showStatus: true,
  enableDelete: false
};
/* harmony default export */ const investigations_InvestigationActivityCard = (InvestigationActivityCard);


/***/ }),

/***/ 60831:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ investigations_InvestigationActivityOutcome)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/client/investigations/DynamicInvestigationResults/index.ts + 3 modules
var DynamicInvestigationResults = __webpack_require__(74100);
// EXTERNAL MODULE: ./src/client/investigations/InvestigationActivityCard.tsx + 1 modules
var InvestigationActivityCard = __webpack_require__(34726);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+lab@4.0.0-alpha.61_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(21035);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+yupify@0.9.2_yup@0.32.9/node_modules/@elephant-healthcare/yupify/dist/esm/index.js + 10 modules
var esm = __webpack_require__(66940);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./src/client/forms/hookForm/DynamicFormFields/index.tsx + 7 modules
var DynamicFormFields = __webpack_require__(82465);
// EXTERNAL MODULE: ./src/client/forms/validation/ValidationContext.ts
var ValidationContext = __webpack_require__(35831);
// EXTERNAL MODULE: ./node_modules/.pnpm/ramda@0.27.0/node_modules/ramda/es/omit.js
var omit = __webpack_require__(99129);
// EXTERNAL MODULE: ./node_modules/.pnpm/ramda@0.27.0/node_modules/ramda/es/clone.js + 1 modules
var clone = __webpack_require__(18164);
// EXTERNAL MODULE: ./src/client/investigations/InvestigationActivitiesProvider.tsx
var InvestigationActivitiesProvider = __webpack_require__(85855);
// EXTERNAL MODULE: ./src/client/investigations/useInvestigationsCache.tsx + 1 modules
var useInvestigationsCache = __webpack_require__(71746);
// EXTERNAL MODULE: ./src/client/investigations/__generated__/InvestigationActivityCardForm.gql.ts
var InvestigationActivityCardForm_gql = __webpack_require__(66876);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+launchdarkly-provider@1.4.4_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/launchdarkly-provider/dist/module.js
var launchdarkly_provider_dist_module = __webpack_require__(45309);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
;// CONCATENATED MODULE: ./src/client/investigations/InvestigationActivityCardForm.tsx


















const COMPLETE_INVESTIGATIONS = lib/* gql */.Ps`
  ${InvestigationActivitiesProvider/* default.fragments.investigationActivity */.ZP.fragments.investigationActivity}
  mutation completeInvestigations($input: [CompleteInvestigationInput]!) {
    completeInvestigations(input: $input) {
      ...InvestigationActivityFragment
    }
  }
`;
const InvestigationActivityCardForm = ({
  investigationId,
  investigationRequest,
  isOngoingAdmissionVisit,
  disabled = false,
  patientUuid
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const orderedSchema = (0,omit/* default */.Z)(["meta"], investigationRequest);
  const validationSchema = react.useMemo(() => {
    const formSchema = (0,esm/* convertOrderedSchema */.B)(orderedSchema);
    return (0,esm/* parseSchema */.Z)((0,clone/* default */.Z)(formSchema));
  }, [orderedSchema]);
  const defaultValues = react.useMemo(() => {
    return validationSchema.getDefault();
  }, [validationSchema]);
  const { appendInvestigationsToCache } = (0,useInvestigationsCache/* default */.Z)(patientUuid);
  const [completeInvestigations] = (0,useMutation/* useMutation */.D)(COMPLETE_INVESTIGATIONS, {
    onCompleted: (data) => appendInvestigationsToCache(data.completeInvestigations, true),
    onError: (error) => {
      dist_default().error(
        formatMessage(
          {
            id: "InvestigationActivityCardForm.completeInvestigation.error",
            defaultMessage: "There was an error completing the investigation: {error}"
          },
          { error: error.message }
        )
      );
    }
  });
  const formMethods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    resolver: (0,yup/* yupResolver */.X)(validationSchema),
    defaultValues
  });
  const {
    formState: { isDirty, isValid }
  } = formMethods;
  return /* @__PURE__ */ react.createElement(ValidationContext/* default.Provider */.Z.Provider, {
    value: { validationSchema }
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    name: "investigation",
    autoComplete: "off"
  }, /* @__PURE__ */ react.createElement(DynamicFormFields/* default */.Z, {
    schema: orderedSchema,
    disabled
  }), disabled ? null : /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    justifyContent: "flex-end"
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    disabled: isDirty ? !isValid : true,
    "data-testid": "investigation-submit-button",
    onClick: formMethods.handleSubmit(
      (values) => completeInvestigations({
        variables: {
          input: [
            {
              id: investigationId,
              outcome: values,
              isInpatient: isOngoingAdmissionVisit
            }
          ]
        }
      })
    )
  }, "Submit")))));
};
const InvestigationCardPlaceholder = () => {
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Skeleton/* default */.Z, {
    variant: "text",
    height: 40
  }), /* @__PURE__ */ react.createElement(Skeleton/* default */.Z, {
    variant: "text",
    height: 40
  }), /* @__PURE__ */ react.createElement(Skeleton/* default */.Z, {
    variant: "text",
    height: 40
  }));
};
const InvestigationCardCurrentVisitDocument = lib/* gql */.Ps`
  query investigationCardCurrentVisit($uuid: String!, $searchWholeTerritory: Boolean) {
    patientByCardId(uuid: $uuid, searchWholeTerritory: $searchWholeTerritory) {
      passportId # requesting this prevents collisions with other requests to the patientByCardId resolver
      patient {
        currentVisit {
          admissionEvent {
            _id
            type
          }
          detentionEvent {
            _id
            type
          }
        }
      }
    }
  }
`;
const InvestigationCardFormForVisit = (props) => {
  var _a, _b;
  const { patientUuid } = props;
  const territoryDataSharingFeatureEnabled = (0,launchdarkly_provider_dist_module/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.patient.territoryDataSharing */.VH.patient.territoryDataSharing
  );
  const { data, loading } = (0,InvestigationActivityCardForm_gql/* useInvestigationCardCurrentVisitQuery */.Qu)({
    variables: {
      uuid: patientUuid,
      searchWholeTerritory: territoryDataSharingFeatureEnabled
    },
    skip: !patientUuid
  });
  const currentVisit = (_b = (_a = data == null ? void 0 : data.patientByCardId) == null ? void 0 : _a.patient) == null ? void 0 : _b.currentVisit;
  const isOngoingAdmissionVisit = !!((currentVisit == null ? void 0 : currentVisit.admissionEvent) || (currentVisit == null ? void 0 : currentVisit.detentionEvent));
  if (loading) {
    return /* @__PURE__ */ react.createElement(InvestigationCardPlaceholder, null);
  }
  return /* @__PURE__ */ react.createElement(InvestigationActivityCardForm, {
    isOngoingAdmissionVisit,
    ...props
  });
};
/* harmony default export */ const investigations_InvestigationActivityCardForm = ((/* unused pure expression or super */ null && (InvestigationActivityCardForm)));

// EXTERNAL MODULE: ./src/client/utils/useUserRole.ts
var useUserRole = __webpack_require__(67858);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+role-definitions@3.0.0/node_modules/@elephant-healthcare/role-definitions/dist/module.js
var role_definitions_dist_module = __webpack_require__(4377);
;// CONCATENATED MODULE: ./src/client/investigations/InvestigationActivityOutcome.tsx






const ROLES_FOR_FORM = [role_definitions_dist_module/* Role.NURSE */.uU.NURSE, role_definitions_dist_module/* Role.DOCTOR */.uU.DOCTOR, role_definitions_dist_module/* Role.TECHNICIAN */.uU.TECHNICIAN];
const InvestigationActivityOutcome = ({
  investigation,
  subtitle,
  defaultExpanded,
  showStatus,
  disabled,
  enableDelete,
  patientUuid
}) => {
  var _a, _b, _c, _d, _e;
  const userRole = (0,useUserRole/* default */.Z)();
  const canCompleteForm = ROLES_FOR_FORM.includes(userRole);
  const { catalogueItem, request, outcome } = investigation;
  const { performer: requester, meta, location: requestLocation } = request;
  const requestedDate = (_b = meta == null ? void 0 : meta.created) != null ? _b : (_a = investigation.meta) == null ? void 0 : _a.created;
  const fulfiller = outcome == null ? void 0 : outcome.performer;
  const fulfilledDate = (_e = (_c = outcome == null ? void 0 : outcome.meta) == null ? void 0 : _c.created) != null ? _e : (_d = investigation.meta) == null ? void 0 : _d.created;
  const outcomeLocation = outcome == null ? void 0 : outcome.location;
  const { title } = catalogueItem;
  const isRequest = !outcome;
  const shouldRenderForm = isRequest && canCompleteForm;
  const property = outcome != null ? outcome : request;
  return /* @__PURE__ */ react.createElement(InvestigationActivityCard/* default */.Z, {
    investigationActivityId: investigation._id,
    title,
    subtitle,
    requester,
    requestedDate,
    fulfiller,
    fulfilledDate,
    isRequested: !outcome,
    defaultExpanded: defaultExpanded != null ? defaultExpanded : shouldRenderForm,
    requestLocation,
    outcomeLocation,
    showStatus,
    enableDelete,
    patientUuid
  }, shouldRenderForm ? /* @__PURE__ */ react.createElement(InvestigationCardFormForVisit, {
    investigationId: investigation._id,
    investigationRequest: investigation.request,
    disabled,
    patientUuid
  }) : /* @__PURE__ */ react.createElement(DynamicInvestigationResults/* default */.Z, {
    property
  }));
};
InvestigationActivityOutcome.defaultProps = {
  disabled: false,
  defaultExpanded: null,
  subtitle: null,
  showStatus: true,
  enableDelete: false
};
/* harmony default export */ const investigations_InvestigationActivityOutcome = (InvestigationActivityOutcome);


/***/ }),

/***/ 56778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97754);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5427);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61800);



const useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((theme) => ({
  root: {
    alignItems: "center",
    background: theme.palette.info.main,
    borderRadius: "4px",
    display: "flex",
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    height: "fit-content"
  }
}));
const RequestedBubble = ({ children, className }) => {
  const classes = useStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(classes.root, className),
    variant: "body2",
    "data-testid": "investigation-requested-bubble"
  }, children);
};
RequestedBubble.defaultProps = {
  className: void 0
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RequestedBubble);


/***/ }),

/***/ 97270:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12850);
/* harmony import */ var _InvestigationActivitiesProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85855);
/* harmony import */ var _RequestedBubble__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56778);




const RequestedCountBubble = () => {
  const { data } = (0,_InvestigationActivitiesProvider__WEBPACK_IMPORTED_MODULE_1__/* .useInvestigationActivitiesContext */ .DD)();
  const requestedCount = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    var _a;
    const items = (_a = data == null ? void 0 : data.investigationActivitiesPaginatedOffset) == null ? void 0 : _a.items;
    if (!items) {
      return "-";
    }
    const count = items.reduce((acc, curr) => {
      if (curr.__typename === "TestResult" || curr.outcome) {
        return acc;
      }
      return acc + 1;
    }, 0);
    return count;
  }, [data]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_RequestedBubble__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", null, requestedCount, " ", /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    id: "investigationActivity.requestedCount.requested",
    defaultMessage: "Requested Investigations"
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (react__WEBPACK_IMPORTED_MODULE_0__.memo(RequestedCountBubble));


/***/ }),

/***/ 30053:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "II": () => (/* binding */ InvestigationActivitiesProviderDocument),
/* harmony export */   "tt": () => (/* binding */ useInvestigationActivitiesProviderQuery)
/* harmony export */ });
/* unused harmony export useInvestigationActivitiesProviderLazyQuery */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24520);
/* harmony import */ var _clinical_engine_investigationActivities_generated_graphql_gql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56576);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41552);



const defaultOptions = {};
const InvestigationActivitiesProviderDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps`
    query InvestigationActivitiesProvider($input: InvestigationActivitiesInput!, $offset: Int!, $limit: Int!) {
  investigationActivitiesPaginatedOffset(input: $input, offset: $offset, limit: $limit) {
    items {
      ...InvestigationActivityFragment
      ... on TestResult {
        _id
        clinic
        interpreter
        patientId: patient
        results {
          investigation
          name
          result {
            name
            value
            displayName
            unit
          }
        }
        meta {
          created
          updated
        }
      }
    }
    total
    hasMore
    offset
    limit
  }
}
    ${_clinical_engine_investigationActivities_generated_graphql_gql__WEBPACK_IMPORTED_MODULE_0__/* .InvestigationActivityFragmentFragmentDoc */ .T}`;
function useInvestigationActivitiesProviderQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(InvestigationActivitiesProviderDocument, options);
}
function useInvestigationActivitiesProviderLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InvestigationActivitiesProviderDocument, options);
}


/***/ }),

/***/ 66876:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qu": () => (/* binding */ useInvestigationCardCurrentVisitQuery)
/* harmony export */ });
/* unused harmony exports CompleteInvestigationsDocument, useCompleteInvestigationsMutation, InvestigationCardCurrentVisitDocument, useInvestigationCardCurrentVisitLazyQuery */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24520);
/* harmony import */ var _clinical_engine_investigationActivities_generated_graphql_gql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56576);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41552);



const defaultOptions = {};
const CompleteInvestigationsDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps`
    mutation completeInvestigations($input: [CompleteInvestigationInput]!) {
  completeInvestigations(input: $input) {
    ...InvestigationActivityFragment
  }
}
    ${_clinical_engine_investigationActivities_generated_graphql_gql__WEBPACK_IMPORTED_MODULE_0__/* .InvestigationActivityFragmentFragmentDoc */ .T}`;
function useCompleteInvestigationsMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation(CompleteInvestigationsDocument, options);
}
const InvestigationCardCurrentVisitDocument = _apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps`
    query investigationCardCurrentVisit($uuid: String!, $searchWholeTerritory: Boolean) {
  patientByCardId(uuid: $uuid, searchWholeTerritory: $searchWholeTerritory) {
    passportId
    patient {
      currentVisit {
        admissionEvent {
          _id
          type
        }
        detentionEvent {
          _id
          type
        }
      }
    }
  }
}
    `;
function useInvestigationCardCurrentVisitQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a(InvestigationCardCurrentVisitDocument, options);
}
function useInvestigationCardCurrentVisitLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InvestigationCardCurrentVisitDocument, options);
}


/***/ }),

/***/ 2818:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ requestedInvestigationTranslation)
/* harmony export */ });
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11313);

const requestedInvestigationTranslation = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "investigationActivity.requested",
  defaultMessage: "Requested"
});


/***/ }),

/***/ 73152:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": () => (/* binding */ linkToPatientInvestigationsNew)
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28183);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _patient_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90806);


const appendSearch = (params) => {
  return (0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(params, { addQueryPrefix: true });
};
function linkToPatientInvestigationsNew(opts = {}) {
  const search = {
    patientUuid: opts.patientUuid
  };
  return `${(0,_patient_links__WEBPACK_IMPORTED_MODULE_1__/* .linkToPatient */ .i)()}/investigations/new${appendSearch(search)}`;
}


/***/ }),

/***/ 22129:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ newInvestigations_InvestigationSelectField)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./src/client/components/AutoSuggest/FuseAutocomplete.tsx
var FuseAutocomplete = __webpack_require__(72028);
// EXTERNAL MODULE: ./src/client/components/AutoSuggest/useFuseSearchEngine.ts
var useFuseSearchEngine = __webpack_require__(14679);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./src/client/components/AutoSuggest/Suggestion.jsx
var Suggestion = __webpack_require__(72853);
// EXTERNAL MODULE: ./src/client/components/AutoSuggest/HighlightedString.tsx
var HighlightedString = __webpack_require__(30071);
;// CONCATENATED MODULE: ./src/client/investigations/newInvestigations/InvestigationOption.tsx




const InvestigationOption = ({ option }) => {
  const { item, matches } = option;
  const matchesTitle = matches == null ? void 0 : matches.find((match) => match.key.endsWith("title"));
  const keywordMatches = matches == null ? void 0 : matches.filter(
    (match) => !match.key.endsWith("title")
  );
  return /* @__PURE__ */ react.createElement(Suggestion/* SuggestionWrapper */.C, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, /* @__PURE__ */ react.createElement(HighlightedString/* default */.Z, {
    string: (matchesTitle == null ? void 0 : matchesTitle.value) || item.title || "",
    indices: (matchesTitle == null ? void 0 : matchesTitle.indices) || []
  })), keywordMatches.length > 0 && /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, "(", keywordMatches.map(({ value, indices }, i, arr) => /* @__PURE__ */ react.createElement(react.Fragment, {
    key: `${value}-${indices.join("-")}`
  }, /* @__PURE__ */ react.createElement(HighlightedString/* default */.Z, {
    string: value,
    indices
  }), i !== arr.length - 1 && ", ")), ")"));
};
/* harmony default export */ const newInvestigations_InvestigationOption = (react.memo(InvestigationOption));

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(81381);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(66264);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(86377);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var dist_module = __webpack_require__(10353);
;// CONCATENATED MODULE: ./src/client/investigations/newInvestigations/SearchInput.jsx





const useStyles = (0,dist_module/* makeStyles */.Z)((theme) => ({
  colorInvestigations: {
    color: theme.palette.investigation.main
  }
}));
const SearchInput = (props) => {
  const classes = useStyles();
  return /* @__PURE__ */ react.createElement(TextField/* default */.Z, {
    ...props,
    InputProps: {
      ...props.InputProps,
      startAdornment: /* @__PURE__ */ react.createElement(InputAdornment/* default */.Z, {
        position: "start"
      }, /* @__PURE__ */ react.createElement(Search/* default */.Z, {
        classes: { root: classes.colorInvestigations }
      }))
    }
  });
};
/* harmony default export */ const newInvestigations_SearchInput = (SearchInput);

// EXTERNAL MODULE: ./src/client/observability/uxAnalytics/useTracing.ts
var useTracing = __webpack_require__(13893);
// EXTERNAL MODULE: ./src/client/investigations/tracing.ts
var tracing = __webpack_require__(475);
;// CONCATENATED MODULE: ./src/client/investigations/newInvestigations/InvestigationSelect.tsx








const FUSE_OPTIONS = {
  keys: [
    {
      name: "keywords",
      weight: 0.3
    },
    { name: "title", weight: 0.7 }
  ]
};
const inputPlaceholder = (0,lib/* defineMessage */.Em)({
  id: "investigation.select.placeholder",
  defaultMessage: "Find investigation"
});
const noOptionsMsg = (0,lib/* defineMessage */.Em)({
  id: "investigation.select.noOptions",
  defaultMessage: "Start typing to search for an investigation..."
});
const InvestigationSelect = react.forwardRef(
  ({
    investigationList,
    autoFocus,
    analytics = {
      focusSpan: tracing/* NewInvestigationTracingSpans.INVESTIGATION_SEARCH_FOCUS */.s.INVESTIGATION_SEARCH_FOCUS,
      selectEvent: tracing/* NewInvestigationTracingEvents */.M[tracing/* NewInvestigationTracingSpans.INVESTIGATION_SEARCH_FOCUS */.s.INVESTIGATION_SEARCH_FOCUS].OPTION_SELECTED
    },
    ...props
  }, ref) => {
    const { formatMessage } = (0,useIntl/* default */.Z)();
    const searchEngine = (0,useFuseSearchEngine/* default */.Z)(investigationList, FUSE_OPTIONS);
    const { startSpan, endSpan, addEventToSpan } = (0,useTracing/* useTracing */.k)();
    return /* @__PURE__ */ react.createElement(FuseAutocomplete/* default */.Z, {
      ...props,
      value: null,
      noOptionsText: formatMessage(noOptionsMsg),
      searchEngine,
      getOptionLabel: (option) => {
        var _a, _b;
        return (_b = (_a = option == null ? void 0 : option.item) == null ? void 0 : _a.title) != null ? _b : "";
      },
      renderOption: (option) => {
        return /* @__PURE__ */ react.createElement(newInvestigations_InvestigationOption, {
          option
        });
      },
      onFocus: () => {
        startSpan(analytics.focusSpan);
      },
      onBlur: () => {
        endSpan(analytics.focusSpan);
      },
      onChange: (option, reason) => {
        var _a;
        addEventToSpan(analytics.selectEvent, { investigationId: option.id });
        (_a = props.onChange) == null ? void 0 : _a.call(props, option, reason);
      },
      renderInput: (params) => {
        return /* @__PURE__ */ react.createElement(newInvestigations_SearchInput, {
          autoFocus,
          autoComplete: "off",
          name: "investigation",
          label: null,
          placeholder: formatMessage(inputPlaceholder),
          InputProps: { ...params.InputProps, type: "search" },
          ...params,
          inputProps: {
            ...params.inputProps,
            id: "investigation-select-input"
          },
          inputRef: ref,
          "data-testid": "investigation-select-input"
        });
      }
    });
  }
);
/* harmony default export */ const newInvestigations_InvestigationSelect = (InvestigationSelect);

;// CONCATENATED MODULE: ./src/client/investigations/newInvestigations/InvestigationSelectField.tsx


const InvestigationSelectField = react.forwardRef(
  ({
    investigationList,
    appendInvestigation,
    analytics,
    disabled = false
  }, ref) => {
    const [inputValue, setInputValue] = react.useState("");
    return /* @__PURE__ */ react.createElement(newInvestigations_InvestigationSelect, {
      inputValue,
      investigationList,
      onChange: (value, reason) => {
        if (reason === "select-option") {
          appendInvestigation(value);
          setInputValue("");
        }
      },
      onInputChange: (_e, val) => setInputValue(val),
      ref,
      autoFocus: true,
      analytics,
      disabled
    });
  }
);
/* harmony default export */ const newInvestigations_InvestigationSelectField = (react.memo(InvestigationSelectField));


/***/ }),

/***/ 71011:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ investigationStatusStyles)
/* harmony export */ });
const investigationStatusStyles = (theme) => ({
  requestedBubble: {
    marginLeft: "10px"
  },
  checkIcon: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "20px",
    padding: "5px",
    color: "#ffffff"
  }
});


/***/ }),

/***/ 475:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ NewInvestigationTracingEvents),
/* harmony export */   "s": () => (/* binding */ NewInvestigationTracingSpans)
/* harmony export */ });
var NewInvestigationTracingSpans = /* @__PURE__ */ ((NewInvestigationTracingSpans2) => {
  NewInvestigationTracingSpans2["ROOT"] = "newInvestigation";
  NewInvestigationTracingSpans2["INVESTIGATION_SEARCH_FOCUS"] = "newInvestigation.investigationSearchFocus";
  NewInvestigationTracingSpans2["SUBMIT"] = "newInvestigation.submit";
  return NewInvestigationTracingSpans2;
})(NewInvestigationTracingSpans || {});
const NewInvestigationTracingEvents = {
  ["newInvestigation" /* ROOT */]: {
    BEGIN: `${"newInvestigation" /* ROOT */}.begin`
  },
  ["newInvestigation.investigationSearchFocus" /* INVESTIGATION_SEARCH_FOCUS */]: {
    OPTION_SELECTED: `${"newInvestigation.investigationSearchFocus" /* INVESTIGATION_SEARCH_FOCUS */}.optionSelected`
  },
  ["newInvestigation.submit" /* SUBMIT */]: {
    SUCCESS: `${"newInvestigation.submit" /* SUBMIT */}.success`,
    FAILURE: `${"newInvestigation.submit" /* SUBMIT */}.failure`
  }
};


/***/ }),

/***/ 71746:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ investigations_useInvestigationsCache)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(79226);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/client/investigations/InvestigationActivitiesProvider.tsx
var InvestigationActivitiesProvider = __webpack_require__(85855);
// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
;// CONCATENATED MODULE: ./src/client/investigations/getInvestigationProperties.ts
const JSONObjectType = "object";
function meetsRequiredCondition(value, valueRequired) {
  if (valueRequired) {
    return !!value;
  }
  return true;
}
function hasNestedValue(orderedProp) {
  if (orderedProp.type === JSONObjectType && Array.isArray(orderedProp.orderedProperties)) {
    return orderedProp.orderedProperties.map(hasNestedValue).find(Boolean);
  }
  const hasValue = orderedProp.name === "value" && orderedProp.value !== void 0;
  return hasValue;
}
function getInvestigationProperties(orderedProp, loincCodes, options = { valueRequired: true }) {
  var _a, _b, _c;
  const { valueRequired } = options;
  const maybeCode = (_c = (_b = (_a = orderedProp.investigationMeta) == null ? void 0 : _a.coding) == null ? void 0 : _b.loinc) == null ? void 0 : _c.code;
  const maybeValue = orderedProp.value;
  const isLoincProperty = loincCodes.indexOf(maybeCode) > -1;
  if (isLoincProperty && meetsRequiredCondition(maybeValue, valueRequired)) {
    return [orderedProp];
  }
  if (isLoincProperty && !meetsRequiredCondition(maybeValue, valueRequired) && orderedProp.type === JSONObjectType && Array.isArray(orderedProp.orderedProperties) && hasNestedValue(orderedProp)) {
    return [orderedProp];
  }
  if (orderedProp.type === JSONObjectType && Array.isArray(orderedProp.orderedProperties)) {
    const properties = orderedProp.orderedProperties.flatMap(
      (subOrderedProp) => getInvestigationProperties(subOrderedProp, loincCodes, options)
    );
    return properties;
  }
  return [];
}
const getValueAndNameFromProperty = (property) => {
  if (property.value !== void 0) {
    return { name: property.name, value: property.value };
  }
  if (property.type === JSONObjectType && property.orderedProperties) {
    const props = property.orderedProperties.map(getValueAndNameFromProperty);
    if (props.length > 1) {
      const value = props.find((prop) => (prop == null ? void 0 : prop.name) === "value");
      const unit = props.find((prop) => (prop == null ? void 0 : prop.name) === "unit");
      return {
        ...value,
        unit: unit == null ? void 0 : unit.value
      };
    }
    return props[0];
  }
  return null;
};
const getOutcomeValuesFromInvestigation = (loincCode, investigation) => {
  const propertiesWithValues = investigation.outcome.orderedProperties.flatMap(
    (prop) => getInvestigationProperties(prop, [loincCode], { valueRequired: true })
  );
  if (!(propertiesWithValues == null ? void 0 : propertiesWithValues.length)) {
    return void 0;
  }
  const property = propertiesWithValues[0];
  const { value } = getValueAndNameFromProperty(property) || {};
  return value;
};

// EXTERNAL MODULE: ./src/client/inpatient/queries.ts
var queries = __webpack_require__(22251);
// EXTERNAL MODULE: ./src/client/inpatient/vitals/query.ts
var query = __webpack_require__(38839);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/__generated__/queries.gql.ts
var queries_gql = __webpack_require__(94152);
// EXTERNAL MODULE: ./src/client/observability/ObservabilityContext.ts
var ObservabilityContext = __webpack_require__(50527);
;// CONCATENATED MODULE: ./src/client/investigations/useInvestigationsCache.tsx









function buildVisitLineItem(activity, loincCode) {
  var _a;
  const maybeValue = getOutcomeValuesFromInvestigation(loincCode, activity);
  if (!maybeValue) {
    return void 0;
  }
  return {
    id: `${activity._id}:${loincCode}`,
    meta: { __typename: "Meta", created: (_a = activity.outcome) == null ? void 0 : _a.meta.created },
    value: maybeValue,
    unit: null,
    __typename: "VitalLineItem"
  };
}
const formatCareEventFromInvestigation = (investigationActivity) => ({
  __typename: "VisitCareEvent",
  _id: investigationActivity._id,
  type: investigationActivity.outcome ? base_gql/* VisitCareEventAction.InvestigationOutcome */.MG.InvestigationOutcome : base_gql/* VisitCareEventAction.InvestigationRequest */.MG.InvestigationRequest,
  created: investigationActivity.meta.created,
  performer: investigationActivity.request.performer,
  investigationActivity
});
const useInvestigationsCache = (patientUuid) => {
  var _a, _b;
  const { emitErrorEvent } = (0,ObservabilityContext/* useObservabilityContext */.V)();
  const apolloClient = (0,useApolloClient/* useApolloClient */.x)();
  const [findPatientQuery, { data: patientDetailsData }] = (0,queries_gql/* usePatientDetailsLazyQuery */.eB)({
    variables: { uuid: patientUuid }
  });
  (0,react.useEffect)(() => {
    if (patientUuid) {
      findPatientQuery();
    }
  }, [findPatientQuery, patientUuid]);
  const currentVisit = (_b = (_a = patientDetailsData == null ? void 0 : patientDetailsData.patientByCardId) == null ? void 0 : _a.patient) == null ? void 0 : _b.currentVisit;
  const appendInvestigationsToCache = (investigationActivities, careEventOnly = false) => {
    if (!(investigationActivities == null ? void 0 : investigationActivities.length))
      return;
    try {
      if (currentVisit) {
        apolloClient.cache.modify({
          id: apolloClient.cache.identify({
            __typename: "Visit",
            uuid: currentVisit._id
          }),
          fields: {
            careEvents(currentValue) {
              const newRefs = investigationActivities.map(
                (investigation) => {
                  const newCareEventRef = apolloClient.cache.writeFragment({
                    data: formatCareEventFromInvestigation(investigation),
                    fragment: queries/* inpatientGraphql.fragments.investigationCareEventFragment */.MF.fragments.investigationCareEventFragment
                  });
                  return newCareEventRef;
                }
              );
              return [...currentValue, ...newRefs];
            },
            vitals(existingVitalsRef) {
              const {
                id: _,
                __typename: __,
                ...vitals
              } = apolloClient.cache.readFragment({
                id: existingVitalsRef.__ref,
                fragment: query/* VITALS_FRAGMENT */.$,
                fragmentName: "VisitPatientVitals"
              });
              Object.values(vitals).forEach((vital) => {
                const vitalKey = apolloClient.cache.identify(vital);
                const existingData = apolloClient.cache.readFragment({
                  id: vitalKey,
                  fragment: query/* VITALS_FRAGMENT */.$,
                  fragmentName: "VisitPatientVitalFragment"
                });
                const { id: loincCode } = existingData;
                if (!loincCode) {
                  return;
                }
                const values = investigationActivities.map((activity) => {
                  if (!activity.outcome) {
                    return false;
                  }
                  return buildVisitLineItem(activity, loincCode);
                }).filter((el) => el !== void 0);
                if (values.length < 1) {
                  return;
                }
                const newData = {
                  ...existingData,
                  values: [...existingData.values, ...values]
                };
                apolloClient.cache.writeFragment({
                  id: vitalKey,
                  data: newData,
                  fragment: query/* VITALS_FRAGMENT */.$,
                  fragmentName: "VisitPatientVitalFragment"
                });
              });
              return existingVitalsRef;
            }
          }
        });
      }
    } catch (err) {
      emitErrorEvent({
        name: "inpatient.investigations.appendToCache",
        error: err
      });
    }
    if (!careEventOnly) {
      try {
        apolloClient.cache.modify({
          fields: {
            investigationActivitiesPaginatedOffset(input) {
              const newRefs = investigationActivities.map(
                (investigation) => {
                  const newInvestigationRef = apolloClient.cache.writeFragment({
                    data: investigation,
                    fragment: InvestigationActivitiesProvider/* default.fragments.investigationActivity */.ZP.fragments.investigationActivity
                  });
                  return newInvestigationRef;
                }
              );
              return {
                ...input,
                items: [...input.items, ...newRefs],
                total: input.total + 1
              };
            }
          }
        });
      } catch (err) {
        emitErrorEvent({
          name: "patientDetails.investigations.appendToCache",
          error: err
        });
      }
    }
  };
  const removeInvestigationFromCache = (investigationId) => {
    try {
      apolloClient.cache.evict({
        id: apolloClient.cache.identify({
          __typename: "VisitCareEvent",
          _id: investigationId,
          type: "INVESTIGATION_REQUEST"
        })
      });
    } catch (err) {
      emitErrorEvent({
        name: "inpatient.investigations.deleteFromCache",
        error: err
      });
    }
    try {
      apolloClient.cache.evict({
        id: apolloClient.cache.identify({
          __typename: "InvestigationActivity",
          _id: investigationId
        })
      });
    } catch (err) {
      emitErrorEvent({
        name: "patientDetails.investigations.deleteFromCache",
        error: err
      });
    }
    apolloClient.cache.gc();
  };
  return { appendInvestigationsToCache, removeInvestigationFromCache };
};
/* harmony default export */ const investigations_useInvestigationsCache = (useInvestigationsCache);


/***/ }),

/***/ 23251:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Au": () => (/* binding */ SCHOOL_NAME),
/* harmony export */   "Ay": () => (/* binding */ CONSENT_CHILD_ELEPHANT_USE_OF_ANON_DATA),
/* harmony export */   "BD": () => (/* binding */ FACILITY_NAME),
/* harmony export */   "DC": () => (/* binding */ NATIONAL_ID_NUMBER_NAME),
/* harmony export */   "Ew": () => (/* binding */ DOB_NAME),
/* harmony export */   "GD": () => (/* binding */ CONSENT_CHANGE_INFO_LABEL),
/* harmony export */   "H": () => (/* binding */ CONSENT_PRODUCT_MARKETING),
/* harmony export */   "HD": () => (/* binding */ NATIONAL_ID_META_TYPE),
/* harmony export */   "IM": () => (/* binding */ PHONE_OWNERSHIP_NONE),
/* harmony export */   "J7": () => (/* binding */ CONSENT_CHILD_WARNING),
/* harmony export */   "K6": () => (/* binding */ NEXT_OF_KIN_FULL_NAME_NAME),
/* harmony export */   "Ko": () => (/* binding */ NEXT_OF_KIN_COUNTRY_NAME),
/* harmony export */   "LR": () => (/* binding */ PHONE_OWNERSHIP_SHARED),
/* harmony export */   "LS": () => (/* binding */ NEXT_OF_KIN_ADDRESS_LINE_4_NAME),
/* harmony export */   "Le": () => (/* binding */ MARITAL_STATUS_NAME),
/* harmony export */   "Mm": () => (/* binding */ FIRST_NAME_NAME),
/* harmony export */   "Ou": () => (/* binding */ NATIONAL_ID_META_OWNER),
/* harmony export */   "Qh": () => (/* binding */ CONSENT_ADULT_ELEPHANT_USE_OF_ANON_DATA),
/* harmony export */   "Sl": () => (/* binding */ NEW_TO_CLINIC_NAME),
/* harmony export */   "TD": () => (/* binding */ IS_STUDENT_NAME),
/* harmony export */   "Xb": () => (/* binding */ LANGUAGE_NAME),
/* harmony export */   "Z$": () => (/* binding */ PHONE_OWNERSHIP_PERSONAL),
/* harmony export */   "ZD": () => (/* binding */ NEXT_OF_KIN_ADDRESS_LINE_1_NAME),
/* harmony export */   "Zp": () => (/* binding */ CONSENT_CHILD_PRODUCT_MARKETING),
/* harmony export */   "_M": () => (/* binding */ NATIONALITY_NAME),
/* harmony export */   "ap": () => (/* binding */ PHONE_NUMBER_NAME),
/* harmony export */   "c$": () => (/* binding */ NEXT_OF_KIN_ADDRESS_LINE_3_NAME),
/* harmony export */   "c9": () => (/* binding */ NEXT_OF_KIN_NUMBER_NAME),
/* harmony export */   "ds": () => (/* binding */ ADDRESS_LINE_4_NAME),
/* harmony export */   "hV": () => (/* binding */ GENDER_NAME),
/* harmony export */   "jG": () => (/* binding */ PATIENT_HAS_INSURANCE),
/* harmony export */   "jX": () => (/* binding */ INSURANCE_TYPE_NAME),
/* harmony export */   "lC": () => (/* binding */ CONSENT_ADULT_WARNING),
/* harmony export */   "mq": () => (/* binding */ ADDRESS_LINE_1_NAME),
/* harmony export */   "n7": () => (/* binding */ COUNTRY_NAME),
/* harmony export */   "pU": () => (/* binding */ PHONE_OWNERSHIP_NAME),
/* harmony export */   "t0": () => (/* binding */ ADDRESS_LINE_2_NAME),
/* harmony export */   "tR": () => (/* binding */ LAST_NAME_NAME),
/* harmony export */   "tZ": () => (/* binding */ ADDRESS_LINE_3_NAME),
/* harmony export */   "ty": () => (/* binding */ NEXT_OF_KIN_ADDRESS_LINE_2_NAME),
/* harmony export */   "vm": () => (/* binding */ CONSENT_ADULT_PRODUCT_MARKETING),
/* harmony export */   "wG": () => (/* binding */ CONSENT_ELEPHANT_USE_OF_ANON_DATA),
/* harmony export */   "xl": () => (/* binding */ PatientHasInsurance),
/* harmony export */   "xq": () => (/* binding */ NEMIS_NUMBER_NAME),
/* harmony export */   "xv": () => (/* binding */ NEXT_OF_KIN_RELATIONSHIP_NAME),
/* harmony export */   "yJ": () => (/* binding */ MIDDLE_NAME_NAME)
/* harmony export */ });
/* unused harmony exports INSURANCE_NUMBER_NAME, INSURANCE_NATIONAL_ID_NUMBER, INSURANCE_DETAILS_DEPENDENT_MEMBER, INSURANCE_PAYMENT_UP_TO_DATE_NAME, I18N_INSURANCE_TYPE, OTHER_INSURANCE_NUMBER_FIELD_LABEL, DEFAULT_INSURANCE_NUMBER_FIELD_LABEL, CONSENT_CHILD_ELEPHANT_USE_OF_ANON_DATA_LABEL, CONSENT_ADULT_ELEPHANT_USE_OF_ANON_DATA_LABEL */
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11313);

const NEW_TO_CLINIC_NAME = "isNew";
const FIRST_NAME_NAME = "firstName";
const MIDDLE_NAME_NAME = "middleName";
const LAST_NAME_NAME = "lastName";
const DOB_NAME = "dob";
const GENDER_NAME = "gender";
const NATIONAL_ID_NUMBER_NAME = "nationalIdNumber";
const NATIONAL_ID_META_TYPE = "nationalIdMeta.nationalIdType";
const NATIONAL_ID_META_OWNER = "nationalIdMeta.nationalIdOwner";
const PHONE_OWNERSHIP_PERSONAL = "personal";
const PHONE_OWNERSHIP_SHARED = "shared";
const PHONE_OWNERSHIP_NONE = "none";
const PHONE_OWNERSHIP_NAME = "phoneOwnership";
const PHONE_NUMBER_NAME = "phoneNumber";
const FACILITY_NAME = "name";
const COUNTRY_NAME = "address.country";
const ADDRESS_LINE_1_NAME = "address.state";
const ADDRESS_LINE_2_NAME = "address.subCounty";
const ADDRESS_LINE_3_NAME = "address.ward";
const ADDRESS_LINE_4_NAME = "address.street";
const NATIONALITY_NAME = "nationality";
const LANGUAGE_NAME = "locale";
const MARITAL_STATUS_NAME = "maritalStatus";
const SCHOOL_NAME = "education.school";
const NEMIS_NUMBER_NAME = "education.nemisNumber";
const IS_STUDENT_NAME = "education.isStudent";
const PATIENT_HAS_INSURANCE = "insurance.patientHasInsurance";
const INSURANCE_TYPE_NAME = "insurance.insuranceType";
const INSURANCE_NUMBER_NAME = "insurance.insuranceDetails.insuranceNumber";
const INSURANCE_NATIONAL_ID_NUMBER = "insurance.insuranceDetails.nationalIdNumber";
const INSURANCE_DETAILS_DEPENDENT_MEMBER = "insurance.insuranceDetails.dependent-member";
const INSURANCE_PAYMENT_UP_TO_DATE_NAME = "insurance.insuranceDetails.paymentUpToDate";
const NEXT_OF_KIN_FULL_NAME_NAME = "nextOfKin.fullName";
const NEXT_OF_KIN_NUMBER_NAME = "nextOfKin.phoneNumber";
const NEXT_OF_KIN_RELATIONSHIP_NAME = "nextOfKin.relationship";
const NEXT_OF_KIN_COUNTRY_NAME = "nextOfKin.address.country";
const NEXT_OF_KIN_ADDRESS_LINE_1_NAME = "nextOfKin.address.state";
const NEXT_OF_KIN_ADDRESS_LINE_2_NAME = "nextOfKin.address.subCounty";
const NEXT_OF_KIN_ADDRESS_LINE_3_NAME = "nextOfKin.address.ward";
const NEXT_OF_KIN_ADDRESS_LINE_4_NAME = "nextOfKin.address.street";
const CONSENT_ELEPHANT_USE_OF_ANON_DATA = "consent.elephantUseOfAnonData";
const CONSENT_PRODUCT_MARKETING = "consent.productMarketing";
const I18N_INSURANCE_TYPE = {
  OTHER: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
    id: "patient.new.insurance.type.other",
    defaultMessage: "Other"
  }),
  PRIVATE: (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
    id: "patient.new.insurance.type.private",
    defaultMessage: "Private"
  })
};
const OTHER_INSURANCE_NUMBER_FIELD_LABEL = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "patient.new.insurance.numberInput.label.other",
  defaultMessage: "Insurance Details (Number, Expiry Date, etc)"
});
const DEFAULT_INSURANCE_NUMBER_FIELD_LABEL = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "patient.new.insurance.numberInput.label.default",
  defaultMessage: "{type} Insurance Number"
});
const CONSENT_CHILD_WARNING = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "registration.consent.child.warning",
  defaultMessage: "Last step. You need to ask the patient's parent or guardian a question about how their child\u2019s data can be used."
});
const CONSENT_ADULT_WARNING = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "registration.consent.adult.warning",
  defaultMessage: "Last step. You need to ask the patient two questions about how their data can be used."
});
const CONSENT_CHILD_ELEPHANT_USE_OF_ANON_DATA = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "registration.consent.child.elephantUseOfAnonData",
  defaultMessage: "Do you give permission for Elephant to anonymise your child\u2019s data so they can use it to improve healthcare?"
});
const CONSENT_ADULT_ELEPHANT_USE_OF_ANON_DATA = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "registration.consent.adult.elephantUseOfAnonData",
  defaultMessage: "Do you give permission for Elephant to anonymise your data so they can use it to improve healthcare?"
});
const CONSENT_CHILD_ELEPHANT_USE_OF_ANON_DATA_LABEL = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "registration.consent.child.elephantUseOfAnonDataLabel",
  defaultMessage: "Do you give permission for this?"
});
const CONSENT_ADULT_ELEPHANT_USE_OF_ANON_DATA_LABEL = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "registration.consent.adult.elephantUseOfAnonDataLabel",
  defaultMessage: "Do you give permission for this?"
});
const CONSENT_CHILD_PRODUCT_MARKETING = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "registration.consent.child.productMarketing",
  defaultMessage: "Elephant would like to contact you on behalf of your child with relevant product and feature updates that it thinks will be helpful for you. You can change your mind at any time by visiting the web link on your card."
});
const CONSENT_ADULT_PRODUCT_MARKETING = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "registration.consent.adult.productMarketing",
  defaultMessage: "Do you give permission for Elephant to contact you about its products, news and events?"
});
const CONSENT_CHANGE_INFO_LABEL = (0,react_intl__WEBPACK_IMPORTED_MODULE_0__/* .defineMessage */ .Em)({
  id: "registration.consent.changeInfoLabel",
  defaultMessage: "You can change your answers at any time by contacting Elephant through their website or we can message them for you."
});
var PatientHasInsurance = /* @__PURE__ */ ((PatientHasInsurance2) => {
  PatientHasInsurance2["YES"] = "YES";
  PatientHasInsurance2["NO"] = "NO";
  PatientHasInsurance2["UNKNOWN"] = "UNKNOWN";
  return PatientHasInsurance2;
})(PatientHasInsurance || {});


/***/ }),

/***/ 81222:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HN": () => (/* binding */ linkToNewPatientComplete),
/* harmony export */   "JB": () => (/* binding */ linkToNewCardsRegistrationConfirmed),
/* harmony export */   "NW": () => (/* binding */ linkToNewCardsSendPin),
/* harmony export */   "OF": () => (/* binding */ linkToNewPatient),
/* harmony export */   "Pm": () => (/* binding */ linkToNewPatientDuplicates),
/* harmony export */   "V6": () => (/* binding */ linkToNewCardsActivateCard),
/* harmony export */   "hG": () => (/* binding */ linkToNewCardsShowPin),
/* harmony export */   "pQ": () => (/* binding */ linkToNewPatientStep2),
/* harmony export */   "pX": () => (/* binding */ linkToNewPatientRegistrationPayment)
/* harmony export */ });
/* unused harmony exports linkToNew, linkToNewCards */
function linkToNew() {
  return "/new";
}
function linkToNewPatient() {
  return `${linkToNew()}/patient`;
}
function linkToNewPatientDuplicates() {
  return `${linkToNewPatient()}/duplicates`;
}
function linkToNewPatientStep2() {
  return `${linkToNewPatient()}/step2`;
}
function linkToNewPatientRegistrationPayment() {
  return `${linkToNewPatient()}/registration-payment`;
}
function linkToNewPatientComplete() {
  return `${linkToNewPatient()}/complete`;
}
function linkToNewCards() {
  return `${linkToNew()}/cards`;
}
function linkToNewCardsActivateCard() {
  return `${linkToNewCards()}/activate-card`;
}
function linkToNewCardsRegistrationConfirmed() {
  return `${linkToNewCards()}/registration-confirmed`;
}
function linkToNewCardsSendPin() {
  return `${linkToNewCards()}/send-pin`;
}
function linkToNewCardsShowPin() {
  return `${linkToNewCards()}/show-pin`;
}


/***/ })

}]);